// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__hS35c","control":"Checkout_control__ocCA+","actions":"Checkout_actions__REWEf","submit":"Checkout_submit__DKRU9","invalid":"Checkout_invalid__5vmTA"};